{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "Ni na voljo",
    "EMAIL_ADDRESS": "Email Address",
    "PHONE_NUMBER": "Telefonska številka",
    "IDENTIFIER": "Identifikator",
    "COPY_SUCCESSFUL": "Uspešno kopirano v odložišče",
    "COMPANY": "Podjetje",
    "LOCATION": "Lokacija",
    "BROWSER_LANGUAGE": "Jezik brskalnika",
    "CONVERSATION_TITLE": "Podrobnosti pogovora",
    "VIEW_PROFILE": "Ogled profila",
    "BROWSER": "Brskalnik",
    "OS": "Operacijski sistem",
    "INITIATED_FROM": "Začetek iz",
    "INITIATED_AT": "Začeto ob",
    "IP_ADDRESS": "IP naslov",
    "CREATED_AT_LABEL": "Ustvarjeno",
    "NEW_MESSAGE": "Novo sporočilo",
    "CALL": "Pokliči",
    "CALL_INITIATED": "Calling the contact…",
    "CALL_FAILED": "Klica ni bilo mogoče začeti. Poskusite znova.",
    "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
    "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
    "CLICK_TO_EDIT": "Click to edit",
    "VOICE_INBOX_PICKER": {
      "TITLE": "Izberi glasovni predal"
    },
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "S tem stikom ni povezanih nobenih prejšnjih pogovorov.",
      "TITLE": "Prejšnji pogovori"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Oznake stikov",
        "ERROR": "Posodobitev oznak ni uspela"
      },
      "CONVERSATION": {
        "TITLE": "Oznake pogovorov",
        "ADD_BUTTON": "Dodaj oznake"
      },
      "LABEL_SELECT": {
        "TITLE": "Dodaj oznake",
        "PLACEHOLDER": "Išči oznake",
        "NO_RESULT": "Ni najdenih oznak",
        "CREATE_LABEL": "Ustvari novo oznako"
      }
    },
    "MERGE_CONTACT": "Združi stik",
    "CONTACT_ACTIONS": "Dejanja s stikom",
    "MUTE_CONTACT": "Blokiraj stik",
    "UNMUTE_CONTACT": "Odkleni stik",
    "MUTED_SUCCESS": "Ta stik je bil uspešno blokiran. O prihodnjih pogovorih ne boste obveščeni.",
    "UNMUTED_SUCCESS": "Ta stik je bil uspešno odklenjen.",
    "SEND_TRANSCRIPT": "Pošlji prepis",
    "EDIT_LABEL": "Uredi",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Lastne lastnosti",
      "CONTACT_LABELS": "Oznake stika",
      "PREVIOUS_CONVERSATIONS": "Prejšnji pogovori",
      "NO_RECORDS_FOUND": "Ni najdenih atributov"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Uredi stik",
    "TITLE": "Uredi stik",
    "DESC": "Uredi podatke o stiku"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Izbriši stik",
    "TITLE": "Izbriši stik",
    "DESC": "Izbriši podatke o stiku",
    "CONFIRM": {
      "TITLE": "Potrdi brisanje",
      "MESSAGE": "Ali ste prepričani, da želite izbrisati ",
      "YES": "Da, izbriši",
      "NO": "Ne, obdrži"
    },
    "API": {
      "SUCCESS_MESSAGE": "Stik je bil uspešno izbrisan",
      "ERROR_MESSAGE": "Stika ni bilo mogoče izbrisati. Poskusite znova pozneje."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Pošlji",
      "CANCEL": "Prekliči",
      "AVATAR": {
        "LABEL": "Kontaktni avatar"
      },
      "NAME": {
        "PLACEHOLDER": "Vnesite polno ime stika",
        "LABEL": "Polno ime"
      },
      "BIO": {
        "PLACEHOLDER": "Vnesite opis stika",
        "LABEL": "Opis"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Vnesite e-poštni naslov kontakta",
        "LABEL": "Email Address",
        "DUPLICATE": "Ta e-poštni naslov je že v uporabi za drugega uporabnika.",
        "ERROR": "Prosimo, vnesite veljaven e-poštni naslov."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Vnesite telefonsko številko kontakta",
        "LABEL": "Telefonska številka",
        "HELP": "Telefonska številka mora biti v obliki E.164, na primer: +1415555555 [+][koda države][področna koda][lokalna telefonska številka]. Klicno kodo lahko izberete v spustnem meniju.",
        "ERROR": "Telefonska številka naj bo prazna ali v formatu E.164",
        "DIAL_CODE_ERROR": "Prosimo, izberite kodo iz seznama",
        "DUPLICATE": "Ta telefonska številka je že v uporabi za drugega uporabnika."
      },
      "LOCATION": {
        "PLACEHOLDER": "Vnesite lokacijo kontakta",
        "LABEL": "Lokacija"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Vnesite ime podjetja",
        "LABEL": "Ime podjetja"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Vnesite ime države",
        "LABEL": "Ime države",
        "SELECT_PLACEHOLDER": "Izberi",
        "REMOVE": "Odstrani",
        "SELECT_COUNTRY": "Izberi državo"
      },
      "CITY": {
        "PLACEHOLDER": "Vnesite ime mesta",
        "LABEL": "Ime mesta"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Vnesite uporabniško ime za Facebook",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Vnesite uporabniško ime za Twitter",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Vnesite uporabniško ime za LinkedIn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Vnesite uporabniško ime GitHub",
          "LABEL": "Github"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Kontaktni avatar je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Ni bilo mogoče izbrisati avatarja stika. Poskusite znova kasneje."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt je bil uspešno shranjen",
    "ERROR_MESSAGE": "Prišlo je do napake, prosimo, poskusite znova"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Začni pogovor",
    "TITLE": "Nov pogovor",
    "DESC": "Začnite nov pogovor z novim sporočilom.",
    "NO_INBOX": "Ni bilo mogoče najti nabiralnika za začetek novega pogovora s tem stikom.",
    "FORM": {
      "TO": {
        "LABEL": "Za"
      },
      "INBOX": {
        "LABEL": "Preko nabiralnika",
        "PLACEHOLDER": "Izberite izvorni nabiralnik",
        "ERROR": "Izberite nabiralnik"
      },
      "SUBJECT": {
        "LABEL": "Zadeva",
        "PLACEHOLDER": "Zadeva",
        "ERROR": "Zadeva ne sme biti prazna"
      },
      "MESSAGE": {
        "LABEL": "Sporočilo",
        "PLACEHOLDER": "Tukaj napišite svoje sporočilo",
        "ERROR": "Sporočilo ne sme biti prazno"
      },
      "ATTACHMENTS": {
        "SELECT": "Izberite datoteke",
        "HELP_TEXT": "Povlecite in spustite datoteke sem ali izberite datoteke za pripenjanje"
      },
      "SUBMIT": "Pošlji sporočilo",
      "CANCEL": "Prekliči",
      "SUCCESS_MESSAGE": "Sporočilo poslano!",
      "GO_TO_CONVERSATION": "Poglej",
      "ERROR_MESSAGE": "Pošiljanje ni uspelo! poskusi znova"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Družbeni profili"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Dodaj lastno lastnost",
    "COPY_SUCCESSFUL": "Uspešno kopirano v odložišče",
    "SHOW_MORE": "Prikaži vse atribute",
    "SHOW_LESS": "Prikaži manj atributov",
    "ACTIONS": {
      "COPY": "Kopiraj atribut",
      "DELETE": "Izbriši atribut",
      "EDIT": "Uredi atribut"
    },
    "ADD": {
      "TITLE": "Ustvari lastno lastnost",
      "DESC": "Dodaj dodatne informacije temu stiku."
    },
    "FORM": {
      "CREATE": "Dodaj lastnost",
      "CANCEL": "Prekliči",
      "NAME": {
        "LABEL": "Ime po meri atributa",
        "PLACEHOLDER": "Na primer: identifikator trgovine",
        "ERROR": "Neveljavno ime po meri atributa"
      },
      "VALUE": {
        "LABEL": "Vrednost atributa",
        "PLACEHOLDER": "Na primer: 11901 "
      },
      "ADD": {
        "TITLE": "Ustvari nov atribut ",
        "SUCCESS": "Atribut je bil uspešno dodan",
        "ERROR": "Dodajanje atributa ni bilo mogoče. Poskusite znova kasneje"
      },
      "UPDATE": {
        "SUCCESS": "Atribut je bil uspešno posodobljen",
        "ERROR": "Posodobitev atributa ni bila mogoča. Poskusite znova kasneje"
      },
      "DELETE": {
        "SUCCESS": "Atribut je bil uspešno izbrisan",
        "ERROR": "Brisanje atributa ni bilo mogoče. Poskusite znova kasneje"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Dodaj atribute",
        "PLACEHOLDER": "Išči atribute",
        "NO_RESULT": "Ni najdenih atributov"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Izberite vrednost",
          "SEARCH_INPUT_PLACEHOLDER": "Išči vrednost",
          "NO_RESULT": "Ni najdenih rezultatov"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Zahtevana je veljavna vrednost",
      "INVALID_URL": "Neveljaven URL",
      "INVALID_INPUT": "Neveljaven vnos"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Združi stike",
    "DESCRIPTION": "Združi stike, da združiš dva profila v enega, vključno z vsemi atributi in pogovori. V primeru konflikta imajo prednost atributi primarnega stika.",
    "PRIMARY": {
      "TITLE": "Primarni stik",
      "HELP_LABEL": "Za izbris"
    },
    "PARENT": {
      "TITLE": "Stik za združitev",
      "PLACEHOLDER": "Išči stik",
      "HELP_LABEL": "Za obdržati"
    },
    "SUMMARY": {
      "TITLE": "Povzetek",
      "DELETE_WARNING": "Stik <strong>{primaryContactName}</strong> bo izbrisan.",
      "ATTRIBUTE_WARNING": "Podatki stika <strong>{primaryContactName}</strong> bodo kopirani na <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Nekaj je šlo narobe. Poskusite znova pozneje."
    },
    "FORM": {
      "SUBMIT": " Združi stike",
      "CANCEL": "Prekliči",
      "CHILD_CONTACT": {
        "ERROR": "Izberite otroški stik za združitev"
      },
      "SUCCESS_MESSAGE": "Stik je bil uspešno združen",
      "ERROR_MESSAGE": "Stikov ni bilo mogoče združiti, poskusite znova!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakti",
      "SEARCH_TITLE": "Išči stike",
      "ACTIVE_TITLE": "Aktivni stiki",
      "SEARCH_PLACEHOLDER": "Iskanje ...",
      "MESSAGE_BUTTON": "Sporočilo",
      "SEND_MESSAGE": "Pošlji sporočilo",
      "BLOCK_CONTACT": "Blokiraj stik",
      "UNBLOCK_CONTACT": "Odstrani blokado stika",
      "BREADCRUMB": {
        "CONTACTS": "Kontakti"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Dodaj stik",
          "EXPORT_CONTACT": "Izvozi stike",
          "IMPORT_CONTACT": "Uvozi stike",
          "SAVE_CONTACT": "Shrani stik",
          "EMAIL_ADDRESS_DUPLICATE": "Ta e-poštni naslov je že v uporabi za drugega uporabnika.",
          "PHONE_NUMBER_DUPLICATE": "Ta telefonska številka je že v uporabi za drugega uporabnika.",
          "SUCCESS_MESSAGE": "Uporabnik je bil uspešno shranjen",
          "ERROR_MESSAGE": "Ni bilo mogoče shraniti uporabnika. Poskusite znova pozneje."
        },
        "BLOCK_SUCCESS_MESSAGE": "Ta stik je uspešno blokiran",
        "BLOCK_ERROR_MESSAGE": "Ni mogoče blokirati stika. Poskusite znova pozneje.",
        "UNBLOCK_SUCCESS_MESSAGE": "Blokada stika je bila uspešno odstranjena",
        "UNBLOCK_ERROR_MESSAGE": "Ni mogoče odstraniti blokade stika. Poskusite znova pozneje.",
        "IMPORT_CONTACT": {
          "TITLE": "Uvozi stike",
          "DESCRIPTION": "Uvozi stike prek CSV datoteke.",
          "DOWNLOAD_LABEL": "Prenesite vzorčno datoteko za uvoz.",
          "LABEL": "CSV datoteka:",
          "CHOOSE_FILE": "Izberi datoteko",
          "CHANGE": "Spremeni",
          "CANCEL": "Prekliči",
          "IMPORT": "Uvozi",
          "SUCCESS_MESSAGE": "O uvozu boste obveščeni po e-pošti, ko bo postopek končan.",
          "ERROR_MESSAGE": "Prišlo je do napake, prosimo, poskusite znova"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Izvozi stike",
          "DESCRIPTION": "Hitro izvozite datoteko s podrobnimi podatki o svojih stikih",
          "CONFIRM": "Izvozi",
          "SUCCESS_MESSAGE": "Izvoz je v teku. O tem boste obveščeni po e-pošti, ko bo datoteka za izvoz pripravljena za prenos.",
          "ERROR_MESSAGE": "Prišlo je do napake, prosimo, poskusite znova"
        },
        "SORT_BY": {
          "LABEL": "Razvrsti po",
          "OPTIONS": {
            "NAME": "Ime",
            "EMAIL": "E-pošta",
            "PHONE_NUMBER": "Telefonska številka",
            "COMPANY": "Podjetje",
            "COUNTRY": "Država",
            "CITY": "Mesto",
            "LAST_ACTIVITY": "Zadnja aktivnost",
            "CREATED_AT": "Ustvarjeno ob"
          }
        },
        "ORDER": {
          "LABEL": "Razvrščanje",
          "OPTIONS": {
            "ASCENDING": "Naraščajoče",
            "DESCENDING": "Padajoče"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Ali želite shraniti ta filter?",
            "CONFIRM": "Shrani filter",
            "LABEL": "Ime",
            "PLACEHOLDER": "Vnesite ime filtra",
            "ERROR": "Vnesite veljavno ime",
            "SUCCESS_MESSAGE": "Filter je bil uspešno shranjen",
            "ERROR_MESSAGE": "Filtra ni bilo mogoče shraniti. Poskusite znova pozneje."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potrdite brisanje",
            "DESCRIPTION": "Ste prepričani, da želite izbrisati ta filter?",
            "CONFIRM": "Da, izbriši",
            "CANCEL": "Ne, prekliči",
            "SUCCESS_MESSAGE": "Filter je bil uspešno izbrisan",
            "ERROR_MESSAGE": "Filtra ni bilo mogoče izbrisati. Poskusite znova pozneje."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Ime",
      "EMAIL": "E-pošta",
      "PHONE_NUMBER": "Telefonska številka",
      "IDENTIFIER": "Identifikator",
      "COUNTRY": "Država",
      "CITY": "Mesto",
      "COMPANY": "Podjetje",
      "CREATED_AT": "Ustvarjeno ob",
      "LAST_ACTIVITY": "Zadnja aktivnost",
      "REFERER_LINK": "Napotitvena povezava",
      "BLOCKED": "Blokirano",
      "BLOCKED_TRUE": "Da",
      "BLOCKED_FALSE": "Ne",
      "BUTTONS": {
        "CLEAR_FILTERS": "Odstrani filtre",
        "UPDATE_SEGMENT": "Posodobi segment",
        "APPLY_FILTERS": "Uporabi filtre",
        "ADD_FILTER": "Dodaj filter"
      },
      "TITLE": "Filtriraj stike",
      "EDIT_SEGMENT": "Uredi segment",
      "SEGMENT": {
        "LABEL": "Ime segmenta",
        "INPUT_PLACEHOLDER": "Vnesite ime segmenta"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} več filtrov",
        "CLEAR_FILTERS": "Odstrani filtre"
      }
    },
    "CARD": {
      "OF": "od",
      "VIEW_DETAILS": "Poglej podrobnosti",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Uredi podatke o stiku",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Vnesite ime"
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Vnesite priimek"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Vnesite e-poštni naslov",
            "DUPLICATE": "Ta e-poštni naslov je že v uporabi za drugega uporabnika."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Vnesite telefonsko številko",
            "DUPLICATE": "Ta telefonska številka je že v uporabi za drugega uporabnika."
          },
          "CITY": {
            "PLACEHOLDER": "Vnesite ime mesta"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Izberite državo"
          },
          "BIO": {
            "PLACEHOLDER": "Vnesite opis"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Vnesite ime podjetja"
          }
        },
        "UPDATE_BUTTON": "Posodobi stik",
        "SUCCESS_MESSAGE": "Stik je bil uspešno posodobljen",
        "ERROR_MESSAGE": "Posodobitev stika ni uspela. Poskusite znova kasneje."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Uredi povezave do družbenih omrežij",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Dodaj Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Dodajte GitHub"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Dodaj Instagram"
          },
          "TELEGRAM": {
            "PLACEHOLDER": "Dodaj Telegram"
          },
          "TIKTOK": {
            "PLACEHOLDER": "Dodaj TikTok"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Dodaj LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Dodaj Twitter"
          }
        }
      },
      "DELETE_CONTACT": {
        "MESSAGE": "Ta dejanje je trajno in nepovratno.",
        "BUTTON": "Izbriši zdaj"
      }
    },
    "DETAILS": {
      "CREATED_AT": "Ustvarjeno {date}",
      "LAST_ACTIVITY": "Zadnja aktivnost {date}",
      "DELETE_CONTACT_DESCRIPTION": "Trajno izbriši ta stik. Teh dejanj ni mogoče razveljaviti",
      "DELETE_CONTACT": "Izbriši stik",
      "DELETE_DIALOG": {
        "TITLE": "Potrdi brisanje",
        "DESCRIPTION": "Ali ste prepričani, da želite izbrisati ta stik?",
        "CONFIRM": "Da, izbriši",
        "API": {
          "SUCCESS_MESSAGE": "Stik je bil uspešno izbrisan",
          "ERROR_MESSAGE": "Stika ni bilo mogoče izbrisati. Poskusite znova kasneje."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Nalaganje avatarja ni uspelo. Poskusite znova kasneje.",
          "SUCCESS_MESSAGE": "Profilna slika je bila uspešno naložena"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Profilna slika je bila uspešno izbrisana",
          "ERROR_MESSAGE": "Brisanje avatarja ni uspelo. Poskusite znova kasneje."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Atributi",
        "HISTORY": "Zgodovina",
        "NOTES": "Beležke",
        "MEDIA": "Media",
        "MERGE": "Združi"
      },
      "HISTORY": {
        "EMPTY_STATE": "S tem stikom ni povezanih prejšnjih pogovorov"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Išči atribute",
        "UNUSED_ATTRIBUTES": "{count} uporabljen atribut | {count} neuporabljenih atributov",
        "EMPTY_STATE": "V tem računu ni na voljo nobenih prilagojenih atributov stikov. Prilagojen atribut lahko ustvarite v nastavitvah.",
        "YES": "Da",
        "NO": "Ne",
        "TRIGGER": {
          "SELECT": "Izberite vrednost",
          "INPUT": "Vnesite vrednost"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Neveljavna številka",
          "REQUIRED": "Zahtevana je veljavna vrednost",
          "INVALID_INPUT": "Neveljaven vnos",
          "INVALID_URL": "Neveljaven URL",
          "INVALID_DATE": "Neveljaven datum"
        },
        "NO_ATTRIBUTES": "Ni najdenih atributov",
        "API": {
          "SUCCESS_MESSAGE": "Značilnost je bila uspešno posodobljena",
          "DELETE_SUCCESS_MESSAGE": "Značilnost je bila uspešno izbrisana",
          "UPDATE_ERROR": "Posodobitev značilnosti ni uspela. Poskusite znova pozneje",
          "DELETE_ERROR": "Brisanje značilnosti ni uspelo. Poskusite znova pozneje"
        }
      },
      "MERGE": {
        "TITLE": "Združi stik",
        "DESCRIPTION": "Združi dva profila v enega, vključno z vsemi atributi in pogovori. V primeru konflikta imajo prednost atributi primarnega stika.",
        "PRIMARY": "Primarni stik",
        "PRIMARY_HELP_LABEL": "Za shranjevanje",
        "PRIMARY_REQUIRED_ERROR": "Pred nadaljevanjem izberite stik za združitev",
        "PARENT": "Za združitev",
        "PARENT_HELP_LABEL": "Za izbris",
        "EMPTY_STATE": "Ni najdenih stikov",
        "PLACEHOLDER": "Išči primarni stik",
        "SEARCH_PLACEHOLDER": "Išči stik",
        "SEARCH_ERROR_MESSAGE": "Iskanje stikov ni bilo uspešno. Poskusite znova kasneje.",
        "SUCCESS_MESSAGE": "Stik je bil uspešno združen",
        "ERROR_MESSAGE": "Združevanje stikov ni uspelo, poskusite znova!",
        "IS_SEARCHING": "Iskanje ...",
        "BUTTONS": {
          "CANCEL": "Prekliči",
          "CONFIRM": "Združi stik"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Dodaj opombo",
        "WROTE": "je napisal/a",
        "YOU": "Vi",
        "SAVE": "Shrani opombo",
        "ADD_NOTE": "Dodaj opombo za stik",
        "EXPAND": "Razširi",
        "COLLAPSE": "Strni",
        "NO_NOTES": "Ni zapiskov, zapiske lahko dodate na strani s podrobnostmi stika.",
        "EMPTY_STATE": "Ta stik nima pripisanih opomb. Opombo lahko dodaš tako, da vpišeš v zgornje polje.",
        "CONVERSATION_EMPTY_STATE": "Opomb še ni. Uporabite gumb Dodaj opombo za ustvarjanje."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "V tem računu ni najdenih stikov",
      "SUBTITLE": "Začnite dodajati nove stike s klikom na spodnji gumb",
      "BUTTON_LABEL": "Dodaj stik",
      "SEARCH_EMPTY_STATE_TITLE": "Noben stik ne ustreza vašemu iskanju 🔍",
      "LIST_EMPTY_STATE_TITLE": "V tem pogledu ni na voljo nobenih stikov 📋",
      "ACTIVE_EMPTY_STATE_TITLE": "Trenutno ni aktivnih stikov 🌙"
    },
    "LOAD_MORE": "Naloži več"
  },
  "CONTACTS_BULK_ACTIONS": {
    "ASSIGN_LABELS": "Dodeli oznake",
    "REMOVE_LABELS": "Remove Labels",
    "ASSIGN_LABELS_SUCCESS": "Oznake so bile uspešno dodeljene.",
    "ASSIGN_LABELS_FAILED": "Dodeljevanje oznak ni uspelo",
    "REMOVE_LABELS_SUCCESS": "Labels removed successfully.",
    "REMOVE_LABELS_FAILED": "Failed to remove labels",
    "DESCRIPTION": "Izberite oznake, ki jih želite dodati izbranim stikom.",
    "NO_LABELS_FOUND": "Še ni na voljo nobenih oznak.",
    "SELECTED_COUNT": "{count} izbranih",
    "CLEAR_SELECTION": "Počisti izbiro",
    "SELECT_ALL": "Izberi vse ({count})",
    "DELETE_CONTACTS": "Izbriši",
    "DELETE_SUCCESS": "Stiki so bili uspešno izbrisani.",
    "DELETE_FAILED": "Brisanje stikov ni uspelo.",
    "DELETE_DIALOG": {
      "TITLE": "Izbriši izbrane stike",
      "SINGULAR_TITLE": "Izbriši izbran stik",
      "DESCRIPTION": "To bo trajno izbrisalo {count} izbranih stikov. Tega dejanja ni mogoče razveljaviti.",
      "SINGULAR_DESCRIPTION": "To bo trajno izbrisalo izbran stik. Tega dejanja ni mogoče razveljaviti.",
      "CONFIRM_MULTIPLE": "Izbriši stike",
      "CONFIRM_SINGLE": "Izbriši stik"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "Iskanja ni bilo mogoče dokončati. Poskusite znova."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Poglej",
      "SUCCESS_MESSAGE": "Sporočilo je bilo uspešno poslano!",
      "ERROR_MESSAGE": "Pri ustvarjanju pogovora je prišlo do napake. Poskusite znova pozneje.",
      "NO_INBOX_ALERT": "Ni razpoložljivih prejemnikov za začetek pogovora s tem stikom.",
      "CONTACT_SELECTOR": {
        "LABEL": "Za:",
        "TAG_INPUT_PLACEHOLDER": "Za iskanje po imenu, e-pošti ali telefonski številki vnesite najmanj 2-znakovni niz",
        "CONTACT_CREATING": "Ustvarjam stik..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Preko:",
        "BUTTON": "Prikaži mape prejetih sporočil"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Zadeva:",
        "SUBJECT_PLACEHOLDER": "Tukaj vnesite zadevo sporočila",
        "CC_LABEL": "Kopija:",
        "CC_PLACEHOLDER": "Za iskanje po e-pošti vnesite najmanj 2-znakovni niz",
        "BCC_LABEL": "Skrito kopijo:",
        "BCC_PLACEHOLDER": "Za iskanje po e-pošti vnesite najmanj 2-znakovni niz",
        "BCC_BUTTON": "Skrita kopija"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Tukaj napišite svoje sporočilo..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Izberite predlogo",
        "SEARCH_PLACEHOLDER": "Išči predloge",
        "EMPTY_STATE": "Ni najdenih predlog",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp predloga: {templateName}",
          "VARIABLES": "Spremenljivke",
          "BACK": "Nazaj",
          "SEND_MESSAGE": "Pošlji sporočilo"
        }
      },
      "TWILIO_OPTIONS": {
        "LABEL": "Izberi predlogo",
        "SEARCH_PLACEHOLDER": "Išči predloge",
        "EMPTY_STATE": "Ni najdenih predlog",
        "TEMPLATE_PARSER": {
          "BACK": "Nazaj",
          "SEND_MESSAGE": "Pošlji sporočilo"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Zavrzi",
        "SEND": "Pošlji ({keyCode})"
      }
    }
  }
}
